globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.BackToTop = (function()
{
  function BackToTop($html) {
    if($html.length === 1) {
      this.$html = $html;
    }
  }

  BackToTop.prototype =
  {
    init : function(){
      var scrollMax = 500;
      var scroll    = this;

      if(scroll.$html){
        scroll.$html.on('click', function(){
          $('html, body').animate({scrollTop: 0}, 200);
        });

        $(window).scroll(function(){
          if($(window).scrollTop() > scrollMax){
            scroll.$html.show();
          } else {
            scroll.$html.hide();
          }
        });
      }
    }
  }
  return BackToTop;
})();
